import moment from 'moment';
const utility = {
    readFile: (event, data, key) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            data(reader.result);
        };
    },
    formatDateTime: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        return moment(date).format('YYYY-MM-DD hh:mm A');
    },
    formatDate: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        return moment(date).format('YYYY-MM-DD');
    },
    formatDateDMY: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        return moment(date).format('DD-MM-YYYY');
    },
    // Keep existing API name but return numeric month format (DD-MM-YYYY)
    formatDateDDMMMYYYY: (dt) => {
        if (!dt) return "";
        return moment(dt).format('DD-MM-YYYY');
    },
    // Export-friendly datetime with numeric month
    formatExportDateTime: (dt) => {
        if (!dt) return "";
        return moment(dt).format('DD-MM-YYYY hh:mm A');
    },
    formatTime: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        return moment(date).format('HH:mm');
    },
    convertDate(date) {
        var event = new Date(date);
        let date1 = JSON.stringify(event);
        date = date1.slice(1, 11);
        return date;
    },
    hasPermission: (permission, action) => {
        return Number(permission?.[action]) === 1;
    },
    checkViewPermission: (permission, showMessage, navigate) => {
        if (permission?.canView != 1) {
            showMessage("You do not have permission", "danger");
            navigate('/cpnl/unauthorized');
            return false;
        }
        return true;
    },
    convertDateToExcelSerial: (date) => {
        if (!date) return null;
        if (typeof date === 'number') {
            return date > 25569 ? date : null;
        }
        const m = moment(date, [
            moment.ISO_8601,
            'YYYY-MM-DD',
            'YYYY-MM-DD HH:mm:ss',
            'DD-MM-YYYY',
            'DD/MM/YYYY',
            'YYYY/MM/DD',
            'DD-MMM-YYYY'
        ], true);
        const validM = m.isValid() ? m : moment(date);
        if (!validM.isValid()) return null;
        const utcDate = Date.UTC(validM.year(), validM.month(), validM.date());
        const utcEpoch = Date.UTC(1899, 11, 30);
        return Math.round((utcDate - utcEpoch) / (24 * 60 * 60 * 1000));
    },
    formatDbDateTime: (dt) => {
        if (!dt) return "";
        return moment.utc(dt).format('DD-MMM-YYYY hh:mm A');
    }
}

export default utility;
